import { Spinner, SpinnerProps } from '@chakra-ui/react';

type BoldSpinnerProps = SpinnerProps;

const BoldSpinner = (props: BoldSpinnerProps) => (
  <Spinner color="primary.500" thickness="4px" {...props} />
);

export default BoldSpinner;
